import { Unit, UnitPrefix, BaseUnits } from "uom";
import * as UnitTimes from "../unit-times";
import { Newton } from "./force";
/**
 * The derived unit for energy, work, quantity of heat ( <code>J</code> ).
 * One joule is the amount of work done when an applied force of 1 newton moves
 * through a distance of 1 metre in the direction of the force.
 * It is named after the English physicist James Prescott Joule (1818-1889).
 */
export var Joule = UnitTimes.forceByLength("Joule", Newton, BaseUnits.Meter);
// Energy
export var NewtonMeter = UnitTimes.forceByLength("NewtonMeter", Newton, BaseUnits.Meter);
export var Kilojoule = UnitPrefix.Kilo("Kilojoule", Joule);
export var Megajoule = UnitPrefix.Mega("Megajoule", Joule);
export var Btu = Unit.timesNumber("Btu", 52752792631.0 / 50000000.0, Joule);
export var KiloBtu = UnitPrefix.Kilo("KiloBtu", Btu);
export var MegaBtu = UnitPrefix.Mega("MegaBtu", Btu);
export var Therm = Unit.timesNumber("Therm", 100000, Btu);
//# sourceMappingURL=energy.js.map